import { useMemo } from "react";
import { useGetIdentity, useGetList, useTranslate } from "ra-core";
import { SelectInput } from "@/components/ds/admin/select-input";

export const OwnerInput = ({ label }: { label?: string }) => {
  const translate = useTranslate();
  const { identity } = useGetIdentity();

  const { data: rolesRaw, isLoading: rolesLoading } = useGetList("config_roles", {
    pagination: { page: 1, perPage: 100 },
  });
  const { data: usersRaw, isLoading: usersLoading } = useGetList("sales", {
    pagination: { page: 1, perPage: 200 },
  });

  const roles = Array.isArray(rolesRaw) ? rolesRaw : rolesRaw?.data || [];
  const users = Array.isArray(usersRaw) ? usersRaw : usersRaw?.data || [];

  const choices = useMemo(() => {
    if (!identity) return [];
    const writerRoleIds = roles
      .filter((r: any) => r.can_write_business_data)
      .map((r: any) => r.id);

    return users
      .filter((u: any) => writerRoleIds.includes(u.role_id))
      .map((u: any) => ({
        id: u.id,
        name:
          `${u.first_name ?? ""} ${u.last_name ?? ""}`.trim() ||
          u.email ||
          `User #${u.id}`,
      }));
  }, [identity, roles, users]);

  if (rolesLoading || usersLoading || choices.length === 0) {
    // simple skeleton — keeps layout stable, no crash
    return (
      <div className="space-y-2">
        <div className="text-sm font-medium">
          {label ?? translate("crm.deal.field.owner", { _: "Owner" })}
        </div>
        <div className="h-10 rounded-md border bg-muted/30 animate-pulse" />
      </div>
    );
  }

  return (
    <SelectInput
      source="sales_id"
      label={
        label ??
        translate("crm.deal.field.assigned_to", {
          _: "Assigned to",
        })
      }
      choices={choices}
      helperText={false}
    />
  );
};